import { setWishListsSpoolStatus } from "@iewc/Services/CustomWishListsSpoolStatus";
import customLoadStoolItems, { ProductPriceParameter } from "@iewc/Store/Handlers/Custom/CustomLoadStoolItems";
import setSpoolModalOpen from "@iewc/Store/Handlers/Custom/CustomSetSpoolModal";
import { setGA4Event } from "@iewc/Store/Handlers/Utilities/CustomTracking";
import { CustomState } from "@iewc/Store/Reducers";
import { addToChainAfter, makeHandlerChainAwaitable, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { addWishListToCart as addWishListToCartApi } from "@insite/client-framework/Services/CartService";
import { getWishList } from "@insite/client-framework/Services/WishListService";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getWishListState } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import {
    chain,
    ExecuteOnSuccessCallback,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Pages/Cart/Handlers/AddWishListToCart";

replaceInChain(chain, RequestDataFromApi, async props => {
    /* ****** Verndale Customization ************************** */
    const state = props.getState() as CustomState;
    const cartLines = getCurrentCartState(state).value?.cartLines;
    let itemsWithStools: ProductPriceParameter[] = [];
    const itemsWithStool = makeHandlerChainAwaitable<
        Parameters<typeof customLoadStoolItems>[0],
        ProductPriceParameter[]
    >(customLoadStoolItems);
    let showStoolModal = false;

    const listToBeAdded = await getWishList({ wishListId: props.apiParameter.wishListId, expand: ["getAllLines"] });

    const wishListLineCollection = listToBeAdded.wishListLineCollection?.map(line => {
        return {
            id: line.id,
            productId: line.productId,
            qtyOrdered: line.qtyOrdered,
            unitOfMeasure: line.unitOfMeasure,
        };
    });

    itemsWithStools = await itemsWithStool({
        items: wishListLineCollection!,
    })(props.dispatch, props.getState);

    if (!itemsWithStools) {
        props.apiResult = await addWishListToCartApi(props.apiParameter);
        return;
    }

    // Check if there are no changed shared list line quantities
    // Ensure the object exists
    if (!props.apiParameter.changedSharedListLinesQuantities) {
        props.apiParameter.changedSharedListLinesQuantities = {};
    }

    const putUpPricingProducts: string[] = [];

    wishListLineCollection!.forEach(line => {
        const reorderItemHasStool = !!itemsWithStools?.find(item => item.productId === line.productId);
        const itemAlreadyInCart = cartLines?.some(cartLine => cartLine.productId === line.productId);

        if (reorderItemHasStool) {
            putUpPricingProducts.push(line.id);
            if (!itemAlreadyInCart) {
                props.apiParameter.changedSharedListLinesQuantities![line.id] = line.qtyOrdered || 1;
            } else {
                // If the item is already in the cart, we send the quantity as 0
                showStoolModal = true;
                props.apiParameter.changedSharedListLinesQuantities![line.id] = 0;
            }
        } else {
            props.apiParameter.changedSharedListLinesQuantities![line.id] = line.qtyOrdered || 1;
        }
    });

    const setWishlistSpoolsStatus = await setWishListsSpoolStatus({
        wishListId: props.apiParameter.wishListId,
        wishListLineIds: putUpPricingProducts,
    });

    if (!setWishlistSpoolsStatus.successful) {
        console.error("Error setting spool status", setWishlistSpoolsStatus.errorMessage);
    }

    props.apiResult = await addWishListToCartApi(props.apiParameter);

    props.apiResult = {
        ...props.apiResult,
        notAllAddedToCart: showStoolModal,
    };

    // If there are items with stools and no changed quantities, trigger the spool modal
    if (itemsWithStools && itemsWithStools.length > 0 && showStoolModal) {
        if(!state.customSpoolModal.isOpen){
            props.dispatch({
                type: "Custom/SetSpoolModal/CompleteSetIsOpen",
                isOpen: true,
                id: "list-some-items-already-in-cart",
            } as any);
        }else{
            props.dispatch({
                type: "Custom/SetSpoolModal/CompleteSetIsOpen",
                isOpen: false,
            } as any);
        }
    }

    // End Verndale Customization ****************************************************
});

addToChainAfter(chain, ExecuteOnSuccessCallback, async props => {
    const pageType = getCurrentPage(props.getState()).type;

    let additionalInfo = {};
    if (pageType === "MyListsDetailsPage" || pageType === "MyListsPage") {
        const wishlistID = props.getState().pages.myListDetails.wishListId || props.apiParameter.wishListId;

        if (!wishlistID) {
            return;
        }

        const wishlistData = await getWishListState(props.getState(), wishlistID).value;

        additionalInfo = {
            item_list_id: wishlistData?.id,
            item_list_name: wishlistData?.name,
            index: "",
        };
    }

    if (props.apiResult.cartLines && props.apiResult.cartLines.length > 0) {
        setGA4Event(props.apiResult.cartLines, "add_to_cart", additionalInfo);
    }
});
